import React, { useEffect, useRef, FC } from 'react';
import { dayjs } from '@trip-ux/common';
import { PickerElementProps } from './DatePickerTypes';
import { isEqual, isEqualDayjs, classCheck } from './utils';

const TODAY = dayjs();
export const PickerElement: FC<PickerElementProps> = ({
  lang,
  day,
  selectedDate,
  isFocused = false,
  isMonthToggle = false,
  selectDate,
  isHidden = false
}) => {
  const { year, month, date, isDisabled } = day;
  const ref = useRef(null);
  const thisDay = dayjs([year, month, date]).locale(lang);
  useEffect(() => {
    if (isFocused && !isMonthToggle) {
      ref.current.focus();
    }
  }, [isFocused, isMonthToggle]);

  const isSelected = isEqual(selectedDate, day);
  const isCurrentDate = isEqualDayjs(day, TODAY);
  const tabIndex = isSelected && !isDisabled ? 0 : -1;
  return isHidden ? (
    <td className="date-picker-cell empty" />
  ) : (
    <td
      aria-selected={isSelected}
      tabIndex={tabIndex}
      className={`date-picker-cell ${classCheck(isSelected, 'selected')} ${classCheck(
        isCurrentDate,
        'current'
      )} ${classCheck(isFocused, 'focused')} ${classCheck(isDisabled, 'disabled')}`}
      id={`cell-${year}-${month}-${date}`}
      onClick={event => !isDisabled && selectDate(event, year, month, date)}
      ref={ref}
      data-testid={`cell-${year}-${month}-${date}`}
      role="gridcell">
      {date}
    </td>
  );
};
PickerElement.displayName = 'PickerElement';
export default PickerElement;
